/**
 * 짧고 무음인 WAV (data-URI).
 * 정책 판별은 파일이 무음이어도 **unmuted `play()`** 를 본다 — `muted=true` 프로브 금지.
 */
export const SILENT_PROBE_SRC = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
//# sourceMappingURL=silentProbeSrc.js.map